import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { GlobalConstants } from "../common/global-constants";
import { BOItem } from "../models/BOItem.model";
import { BORemission } from "../models/BORemission.model";
import { BOFilter } from "../models/BOFilter";

@Injectable()
export class RemissionService{
    myAppUrl = GlobalConstants.apiURL;
    myApiUrl = 'api/Remission/';

    constructor(private http:HttpClient){}


    saveRemission(rem:BORemission):Observable<number>{
      const httpOptions = {
          headers: new HttpHeaders({'Content-Type': 'application/json'})
        }
        const body=JSON.stringify(rem);
      return this.http.post<number>(this.myAppUrl + this.myApiUrl+'saveRemission',body,httpOptions);
    }

    // getAll():Observable<BOItem[]>{
    //     return this.http.get<BOItem[]>(this.myAppUrl + this.myApiUrl);
    // }
  getAll(filter:BOFilter):Observable<BORemission[]>
    {
      const httpOptions = {
          headers: new HttpHeaders({'Content-Type': 'application/json'})
        }
        const body=JSON.stringify(filter);
      return this.http.post<BORemission[]>(this.myAppUrl + this.myApiUrl + 'getAll',body,httpOptions);
    }
    getRemissionById(remissionId:number):Observable<BORemission>{
        return this.http.get<BORemission>(this.myAppUrl + this.myApiUrl + 'getRemissionById/' + remissionId);
    }

}
